import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  StyledLine,
  StyledLineInside,
  // CardHolder,
  Title,
  ListElement,
  AuthorAndTime,
  Rating,
  FlexContainer
  // Image
} from '../StyledComponents';
import { rootConfig } from '../../../config/config';
import {
  SideBarCardData
  // SideBarCard
} from '../StyledComponents/StyledSideBar';

const List_M_Image = props => {
  // console.log('props: ', props);
  const { title, listItems, maxwidth } = props;

  let cardItems = listItems.map((listItem, index) => {
    return (
      <FlexContainer
        className="pointer"
        direction="column"
        style={{
          width: '18.75rem',
          margin:
            // index % 2 === 0
            // ?
            '0.875rem 0.5rem'
          // : '0.875rem 0 0.875rem 1rem'
        }}
        key={listItem.id}
        onClick={() => navigate(listItem.postSlug)}
      >
        <div className="ImageDiv relative">
          {listItem.rating ? (
            <FlexContainer className="Rating">
              <Rating
                className="absolute right-0"
                width="50px"
                height="50px"
                padding="12px"
                background="#4db2ec"
              >
                <Title
                  className="Rating-Text"
                  fontFamily="Montserrat"
                  fontSize="2.25rem"
                  color="#fff"
                >
                  {listItem.rating}
                </Title>
              </Rating>
            </FlexContainer>
          ) : null}
          {/* <Image
          src={
            listItem.featuredImage
              ? `${rootConfig.imagesRoot}/${listItem.featuredImage.file}`
              : null
          }
          alt={listItem.postSlug}
          // width="300px"
          // height="150px"
        /> */}
          <div
            style={{
              width: '300px',
              height: '150px',
              // background: `url(${rootConfig.imagesRoot}/${
              //   listItem.featuredImage.file
              // })`,
              background: `${
                listItem.featuredImage
                  ? `url(${rootConfig.imagesRoot}/${
                      listItem.featuredImage.file
                    })`
                  : 'black'
              }`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center'
            }}
          />
        </div>
        <SideBarCardData className="h-100">
          <Title
            className="pt2"
            fontFamily="Nunito"
            fontSize="1.25rem"
            fontWeight="bold"
            lineHeight="1.2"
          >
            {listItem.postTitle}
          </Title>
          <AuthorAndTime
            color="#757575"
            fontFamily="Montserrat"
            fontSize="0.75rem"
            fontWeight="normal"
            padding="0.8rem 0 0 0"
          >
            <div>{listItem.postAuthor.authorName}</div>
            <div>{listItem.postDate}</div>
          </AuthorAndTime>
        </SideBarCardData>
      </FlexContainer>
    );
  });

  const navigate = postSlug => {
    postSlug = postSlug.toLowerCase();
    // console.log('postSlug: ', postSlug);
    props.history.push(`/${postSlug}`);
  };

  return (
    <div className={props.className}>
      <ListElement
        className="w-100"
        padding="2.25rem 1.2rem"
        maxwidth={maxwidth}
      >
        <Title
          className="pointer"
          onClick={() =>
            navigate(`${props.history.location.pathname.slice(1)}/${title}`)
          }
          fontFamily="Montserrat"
          fontSize="2.25rem"
          fontWeight="bold"
        >
          {title}
        </Title>
        <StyledLine>
          <StyledLineInside />
        </StyledLine>
        <FlexContainer className="flex-wrap justify-center">
          {cardItems}
        </FlexContainer>
      </ListElement>
    </div>
  );
};

export default withRouter(List_M_Image);
